// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dap-panel {
  background: var(--mrt-surface, #fff);
  border: 1px solid var(--mrt-border, #e8e6e3);
  border-radius: 16px;
  padding: 16px 16px 18px;
  box-shadow: 0 2px 12px rgba(2, 6, 23, 0.06);
  position: sticky;
  top: 72px;
}

.dap-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.dap-panel__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 900;
  color: var(--mrt-text, #1c1917);
}

.dap-panel__head-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.dap-panel__refresh,
.dap-panel__expand {
  font-size: 11px;
  font-weight: 800;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid var(--mrt-border-2, #e5e2dc);
  background: var(--mrt-bg, #f4f3f1);
  color: var(--mrt-text-2, #57534e);
  cursor: pointer;
}

.dap-panel__expand {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  padding: 0;
  color: #1d4ed8;
  border-color: rgba(37, 99, 235, 0.28);
  background: rgba(37, 99, 235, 0.08);
}

.dap-panel__expand:hover {
  background: rgba(37, 99, 235, 0.14);
}

.dap-panel__expand:disabled,
.dap-panel__refresh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── 내결제 펼쳐보기 모달 */
.dap-expand-overlay {
  position: fixed;
  inset: 0;
  z-index: 9800;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 20px 16px;
  box-sizing: border-box;
}

.dap-expand-modal {
  background: #fff;
  border-radius: 18px;
  width: min(1180px, 100%);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
  overflow: hidden;
}

.dap-expand-modal--split {
  width: min(1440px, 100%);
  height: min(84vh, 860px);
}

.dap-expand-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.dap-expand-modal__title {
  margin: 0;
  font-size: 17px;
  font-weight: 900;
  color: #0f172a;
}

.dap-expand-modal__title span {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 750;
  color: #64748b;
}

.dap-expand-modal__body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 16px 18px 20px;
  background: #f8fafc;
}

.dap-expand-split {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.9fr);
  background: #f8fafc;
}

.dap-expand-split__preview {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e2e8f0;
  background: #f1f5f9;
}

.dap-expand-split__preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 14px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.dap-expand-split__preview-title {
  font-size: 14px;
  font-weight: 900;
  color: #0f172a;
  min-width: 0;
}

.dap-expand-split__preview-title span {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dap-expand-split__preview-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.dap-expand-split__preview-body {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 10px 12px 14px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.dap-expand-split__preview-frame {
  width: min(100%, 820px);
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
  overflow: hidden;
  /* 한눈에 들어오게 축소 (Chromium zoom + fallback transform) */
  zoom: 0.9;
}

@supports not (zoom: 1) {
  .dap-expand-split__preview-frame {
    width: min(111%, 920px);
    transform: scale(0.9);
    transform-origin: top center;
  }
}

.dap-expand-split__list {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.dap-expand-split__list-head {
  padding: 12px 14px 8px;
  font-size: 13px;
  font-weight: 900;
  color: #1d4ed8;
  flex-shrink: 0;
}

.dap-expand-split__cards {
  list-style: none;
  margin: 0;
  padding: 0 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.dap-expand-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px 14px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.dap-expand-card--clickable {
  cursor: pointer;
}

.dap-expand-card--clickable:hover {
  border-color: #f9a8d4;
  box-shadow: 0 4px 14px rgba(236, 72, 153, 0.14);
}

.dap-expand-card--selected {
  border-color: #ec4899 !important;
  border-left-color: #db2777 !important;
  background: linear-gradient(180deg, #fdf2f8 0%, #fce7f3 100%) !important;
  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.45), 0 6px 16px rgba(219, 39, 119, 0.18);
  position: relative;
}

.dap-expand-card--selected::before {
  content: '선택됨';
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.02em;
  color: #fff;
  background: #ec4899;
  border-radius: 999px;
  padding: 2px 8px;
  line-height: 1.4;
  box-shadow: 0 1px 3px rgba(190, 24, 93, 0.35);
}

.dap-expand-empty {
  text-align: center;
  padding: 48px 16px;
  color: #64748b;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 960px) {
  .dap-expand-modal--split {
    height: min(88vh, 100%);
  }

  .dap-expand-split {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(42vh, 1fr) minmax(260px, 1fr);
  }

  .dap-expand-split__preview {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
  }
}

@media (max-width: 640px) {
  .dap-expand-overlay {
    padding: 8px;
  }

  .dap-expand-modal {
    border-radius: 14px;
    max-height: 96vh;
  }

  .dap-expand-split__preview-head {
    flex-direction: column;
    align-items: stretch;
  }

  .dap-expand-split__preview-actions {
    width: 100%;
  }

  .dap-expand-split__preview-actions .dap-btn {
    flex: 1 1;
  }
}

.dap-panel__sub {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 600;
  color: var(--mrt-muted, #78716c);
  line-height: 1.45;
}

.dap-panel__err {
  font-size: 11px;
  font-weight: 700;
  color: #b91c1c;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fef2f2;
  margin-bottom: 10px;
}

.dap-panel__muted,
.dap-panel__empty {
  font-size: 12px;
  font-weight: 650;
  color: var(--mrt-muted, #78716c);
  padding: 20px 8px;
  text-align: center;
}

.dap-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: min(60vh, 520px);
  overflow-y: auto;
}

.dap-item {
  border: 1px solid var(--mrt-border-2, #e5e2dc);
  border-radius: 12px;
  padding: 10px 12px;
  background: var(--mrt-surface-2, #fafaf9);
}

.dap-item__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}

.dap-badge {
  font-size: 10px;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 6px;
  background: #e0e7ff;
  color: #3730a3;
}

.dap-badge--wait {
  background: #fef3c7;
  color: #92400e;
}

.dap-item__title {
  font-size: 13px;
  font-weight: 800;
  color: var(--mrt-text, #1c1917);
  margin-bottom: 4px;
}

.dap-item__summary {
  font-size: 11px;
  font-weight: 600;
  color: var(--mrt-text-2, #57534e);
  line-height: 1.4;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.dap-item__actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.dap-btn {
  flex: 1 1;
  padding: 7px 10px;
  border-radius: 8px;
  border: none;
  font-size: 11px;
  font-weight: 900;
  cursor: pointer;
}

.dap-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dap-btn--ok {
  background: #059669;
  color: #fff;
}

.dap-btn--no {
  background: #fee2e2;
  color: #b91c1c;
}

/* ── 미이수 교육자 패널 */
.dti-panel {
  margin-top: 12px;
}

.dti-list {
  max-height: min(40vh, 360px);
}

.dti-item__name {
  font-weight: 900;
  font-size: 14px;
  color: var(--mrt-text, #1c1917);
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.dti-badge {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: #fee2e2;
  color: #b91c1c;
  font-size: 11px;
  font-weight: 800;
}

.dti-item__meta {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  font-weight: 650;
  color: var(--mrt-muted, #78716c);
}

.dti-go {
  margin-top: 12px;
  width: 100%;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(33, 150, 243, 0.35);
  background: rgba(33, 150, 243, 0.08);
  color: #1565c0;
  font-weight: 800;
  font-size: 13px;
  cursor: pointer;
}

.dti-go:hover {
  background: rgba(33, 150, 243, 0.14);
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardApprovalPanel.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,kCAAkC;EAClC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;EAC9B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,wEAAwE;EACxE,mFAAmF;EACnF,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".dap-panel {\n  background: var(--mrt-surface, #fff);\n  border: 1px solid var(--mrt-border, #e8e6e3);\n  border-radius: 16px;\n  padding: 16px 16px 18px;\n  box-shadow: 0 2px 12px rgba(2, 6, 23, 0.06);\n  position: sticky;\n  top: 72px;\n}\n\n.dap-panel__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.dap-panel__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 900;\n  color: var(--mrt-text, #1c1917);\n}\n\n.dap-panel__head-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.dap-panel__refresh,\n.dap-panel__expand {\n  font-size: 11px;\n  font-weight: 800;\n  padding: 5px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--mrt-border-2, #e5e2dc);\n  background: var(--mrt-bg, #f4f3f1);\n  color: var(--mrt-text-2, #57534e);\n  cursor: pointer;\n}\n\n.dap-panel__expand {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 28px;\n  padding: 0;\n  color: #1d4ed8;\n  border-color: rgba(37, 99, 235, 0.28);\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.dap-panel__expand:hover {\n  background: rgba(37, 99, 235, 0.14);\n}\n\n.dap-panel__expand:disabled,\n.dap-panel__refresh:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── 내결제 펼쳐보기 모달 */\n.dap-expand-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9800;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  padding: 20px 16px;\n  box-sizing: border-box;\n}\n\n.dap-expand-modal {\n  background: #fff;\n  border-radius: 18px;\n  width: min(1180px, 100%);\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n  overflow: hidden;\n}\n\n.dap-expand-modal--split {\n  width: min(1440px, 100%);\n  height: min(84vh, 860px);\n}\n\n.dap-expand-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.dap-expand-modal__title {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 900;\n  color: #0f172a;\n}\n\n.dap-expand-modal__title span {\n  margin-left: 8px;\n  font-size: 13px;\n  font-weight: 750;\n  color: #64748b;\n}\n\n.dap-expand-modal__body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 16px 18px 20px;\n  background: #f8fafc;\n}\n\n.dap-expand-split {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 0.9fr);\n  background: #f8fafc;\n}\n\n.dap-expand-split__preview {\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #e2e8f0;\n  background: #f1f5f9;\n}\n\n.dap-expand-split__preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.dap-expand-split__preview-title {\n  font-size: 14px;\n  font-weight: 900;\n  color: #0f172a;\n  min-width: 0;\n}\n\n.dap-expand-split__preview-title span {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dap-expand-split__preview-actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.dap-expand-split__preview-body {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 10px 12px 14px;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.dap-expand-split__preview-frame {\n  width: min(100%, 820px);\n  margin: 0 auto;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);\n  overflow: hidden;\n  /* 한눈에 들어오게 축소 (Chromium zoom + fallback transform) */\n  zoom: 0.9;\n}\n\n@supports not (zoom: 1) {\n  .dap-expand-split__preview-frame {\n    width: min(111%, 920px);\n    transform: scale(0.9);\n    transform-origin: top center;\n  }\n}\n\n.dap-expand-split__list {\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n}\n\n.dap-expand-split__list-head {\n  padding: 12px 14px 8px;\n  font-size: 13px;\n  font-weight: 900;\n  color: #1d4ed8;\n  flex-shrink: 0;\n}\n\n.dap-expand-split__cards {\n  list-style: none;\n  margin: 0;\n  padding: 0 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.dap-expand-card {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 12px 14px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.dap-expand-card--clickable {\n  cursor: pointer;\n}\n\n.dap-expand-card--clickable:hover {\n  border-color: #f9a8d4;\n  box-shadow: 0 4px 14px rgba(236, 72, 153, 0.14);\n}\n\n.dap-expand-card--selected {\n  border-color: #ec4899 !important;\n  border-left-color: #db2777 !important;\n  background: linear-gradient(180deg, #fdf2f8 0%, #fce7f3 100%) !important;\n  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.45), 0 6px 16px rgba(219, 39, 119, 0.18);\n  position: relative;\n}\n\n.dap-expand-card--selected::before {\n  content: '선택됨';\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  font-size: 10px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n  color: #fff;\n  background: #ec4899;\n  border-radius: 999px;\n  padding: 2px 8px;\n  line-height: 1.4;\n  box-shadow: 0 1px 3px rgba(190, 24, 93, 0.35);\n}\n\n.dap-expand-empty {\n  text-align: center;\n  padding: 48px 16px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n@media (max-width: 960px) {\n  .dap-expand-modal--split {\n    height: min(88vh, 100%);\n  }\n\n  .dap-expand-split {\n    grid-template-columns: 1fr;\n    grid-template-rows: minmax(42vh, 1fr) minmax(260px, 1fr);\n  }\n\n  .dap-expand-split__preview {\n    border-right: none;\n    border-bottom: 1px solid #e2e8f0;\n  }\n}\n\n@media (max-width: 640px) {\n  .dap-expand-overlay {\n    padding: 8px;\n  }\n\n  .dap-expand-modal {\n    border-radius: 14px;\n    max-height: 96vh;\n  }\n\n  .dap-expand-split__preview-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .dap-expand-split__preview-actions {\n    width: 100%;\n  }\n\n  .dap-expand-split__preview-actions .dap-btn {\n    flex: 1;\n  }\n}\n\n.dap-panel__sub {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--mrt-muted, #78716c);\n  line-height: 1.45;\n}\n\n.dap-panel__err {\n  font-size: 11px;\n  font-weight: 700;\n  color: #b91c1c;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #fef2f2;\n  margin-bottom: 10px;\n}\n\n.dap-panel__muted,\n.dap-panel__empty {\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--mrt-muted, #78716c);\n  padding: 20px 8px;\n  text-align: center;\n}\n\n.dap-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: min(60vh, 520px);\n  overflow-y: auto;\n}\n\n.dap-item {\n  border: 1px solid var(--mrt-border-2, #e5e2dc);\n  border-radius: 12px;\n  padding: 10px 12px;\n  background: var(--mrt-surface-2, #fafaf9);\n}\n\n.dap-item__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.dap-badge {\n  font-size: 10px;\n  font-weight: 800;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: #e0e7ff;\n  color: #3730a3;\n}\n\n.dap-badge--wait {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.dap-item__title {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--mrt-text, #1c1917);\n  margin-bottom: 4px;\n}\n\n.dap-item__summary {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--mrt-text-2, #57534e);\n  line-height: 1.4;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.dap-item__actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.dap-btn {\n  flex: 1;\n  padding: 7px 10px;\n  border-radius: 8px;\n  border: none;\n  font-size: 11px;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.dap-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dap-btn--ok {\n  background: #059669;\n  color: #fff;\n}\n\n.dap-btn--no {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n/* ── 미이수 교육자 패널 */\n.dti-panel {\n  margin-top: 12px;\n}\n\n.dti-list {\n  max-height: min(40vh, 360px);\n}\n\n.dti-item__name {\n  font-weight: 900;\n  font-size: 14px;\n  color: var(--mrt-text, #1c1917);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.dti-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #fee2e2;\n  color: #b91c1c;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.dti-item__meta {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--mrt-muted, #78716c);\n}\n\n.dti-go {\n  margin-top: 12px;\n  width: 100%;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(33, 150, 243, 0.35);\n  background: rgba(33, 150, 243, 0.08);\n  color: #1565c0;\n  font-weight: 800;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.dti-go:hover {\n  background: rgba(33, 150, 243, 0.14);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
